import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import APIServerIP from "helpers/Sats_api_helper"
 
// GET
export const fetchEventTypes = createAsyncThunk(
  "eventTypes/fetch",
  async () => {
    const res = await axios.get(`${APIServerIP}manage-event-type/fetch-event-types`)
    return res.data.data
  }
)

// ADD
export const addEventType = createAsyncThunk(
  "eventTypes/add",
  async (payload) => {
    const res = await axios.post(`${APIServerIP}manage-event-type/create-event-types`, payload)
    return res.data.data
  }
)

// UPDATE
export const updateEventType = createAsyncThunk(
  "eventTypes/update",
  async ({ id, payload }) => {
    const res = await axios.put(`${APIServerIP}manage-event-type/update-event-types/${id}`, payload)
    return res.data.data
  }
)

// DELETE
export const deleteEventType = createAsyncThunk(
  "eventTypes/delete",
  async (id) => {
    await axios.delete(`${APIServerIP}manage-event-type/delete-event-types/${id}`)
    return id
  }
)

const slice = createSlice({
  name: "eventTypes",
  initialState: {
    data: [],
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEventTypes.fulfilled, (state, action) => {
        state.data = action.payload
      })
      .addCase(addEventType.fulfilled, (state, action) => {
        state.data.push(action.payload)
      })
      .addCase(updateEventType.fulfilled, (state, action) => {
        const index = state.data.findIndex(i => i._id === action.payload._id)
        if (index !== -1) state.data[index] = action.payload
      })
      .addCase(deleteEventType.fulfilled, (state, action) => {
        state.data = state.data.filter(i => i._id !== action.payload)
      })
  }
})

export default slice.reducer